'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function PolicySearchSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const quickLinks = [
    { label: 'Cancellation Policy', href: '#cancellation-policy', icon: 'XCircleIcon' },
    { label: 'Payment Terms', href: '#payment-terms', icon: 'CreditCardIcon' },
    { label: 'Guest Guidelines', href: '#guest-guidelines', icon: 'UserGroupIcon' },
    { label: 'Check-in/Check-out', href: '#booking-terms', icon: 'ClockIcon' },
  ];

  return (
    <section className="py-12 bg-white border-b border-border">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="relative mb-8">
            <input
              type="text"
              placeholder="Search policy information..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-6 py-4 pl-14 bg-muted border border-border rounded-xl text-text-primary placeholder:text-text-secondary focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-300"
            />
            <Icon
              name="MagnifyingGlassIcon"
              size={24}
              className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary"
            />
          </div>

          <div className="flex flex-wrap gap-3 justify-center">
            {quickLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="inline-flex items-center space-x-2 px-5 py-3 bg-muted hover:bg-primary/10 text-text-secondary hover:text-primary rounded-lg border border-border hover:border-primary transition-all duration-300"
              >
                <Icon name={link.icon as any} size={18} />
                <span className="text-sm font-medium">{link.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}